import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/Home";
import SoinsPage from "./pages/Soins";
import AProposPage from "./pages/APropos";
import ZonePage from "./pages/Zone";
import ContactPage from "./pages/Contact";
import { GoogleAnalytics, usePageTracking } from "./lib/analytics";

function AppContent() {
  usePageTracking(); // Track page views on route changes
  
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/soins" element={<SoinsPage />} />
        <Route path="/a-propos" element={<AProposPage />} />
        <Route path="/zone" element={<ZonePage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
